import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalLoginComponent } from 'src/app/components/modals/modal-login/modal-login.component';

@Component({
  standalone: false,
  selector: 'app-edit-report',
  templateUrl: './edit-report.component.html',
  styleUrls: ['./edit-report.component.scss'],
})
export class EditReportComponent implements OnInit {
  @Input() fields: Array<string>;
  @Input() element: any;
  form: UntypedFormGroup
  formSubmitted = false;
  formFields = [];
  emails: Array<string> = [];
  emailModel = '';

  constructor(
    public dialogRef: MatDialogRef<ModalLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({});
    this.formFields = Object.keys(this.data.formFields);
    this.buildForm();
  }

  addNewEmaill() {
    if (this.emailModel.trim()) {
      this.emails.push(this.emailModel);
      this.emailModel = '';
      this.setEmailsForm();
    }
  }

  cancel() {
    this.dialogRef.close('');
  }

  deleteEmail(index) {
    this.emails.splice(index, 1);
    this.setEmailsForm();
  }

  submitForm() {
    this.formSubmitted = true;
    if (this.form.valid && this.emails.length) {
      this.dialogRef.close(this.form.value);
    }
  }

  private buildForm() {
    this.form = this.data.form;
    this.buildEmailsArray(this.form.value.recipients);
    console.log()
  }

  private buildEmailsArray(recipients: string) {
    if (recipients) {
      this.emails = recipients.split(',');
    }
  }

  private setEmailsForm() {
    const recipients = this.emails.join(',');
    this.form.controls.recipients.setValue(recipients);
  }

}
